import {QueryStore, StoreBuilder, SyncedRemoteCollectionStore} from '@softline/core';
import {RdpLogEntry} from './data/rdp-log-entry.model';
import {RdpLogQuery} from './data/rdp-log-query.model';

export const SOFTLINE_FEATURE_RDP_LOG_APP = 'rdpLogApp';
export const SOFTLINE_PERMISSION_RDP_LOG = 'RDPLOG';

export const RdpLogAppStore = new StoreBuilder(SyncedRemoteCollectionStore.create<RdpLogEntry>())
  .add(QueryStore.create<RdpLogQuery>())
  .value;
